import React, { Component } from 'react';
import { connect } from "react-redux";
import TrackVisualizer from './TrackVisualizer.js';

function TracksVisualizer(props) {
    let tracks = props.sequencerEngine.tracks;

    return (
        <div className="tracks-visualizer">
          {tracks.map(track => <TrackVisualizer
                                 currentSubSequenceId={props.currentSubSequence}
                                 track={track}/>)}
        </div>
    );
}

const mapStateToProps = (state, props) => {
    return {
        currentSubSequence: state.sequencer.currentSubSequence[props.sequencerEngine.engineId],
    };
};

export default connect(mapStateToProps, null)(TracksVisualizer);

